export default __webpack_public_path__ + "static/media/icon-user-exchange.da98c19f.svg";